import type { FC, ReactNode } from 'react'

import { useRef } from 'react'
import { ChevronLeft } from 'lucide-react'

import { useDragRail } from '@/lib/anim'
import { Seo } from '@/components/generals/seo'
import { SiteShell } from '@/components/generals/site-shell'
import { PageHero } from '@/components/generals/page-hero'
import { ProjectCard } from '@/components/generals/project-card'
import { projects, workPage } from '@/constants/dentea'

const Work: FC = (): ReactNode => {
    const rail = useRef<HTMLDivElement>(null)

    useDragRail(rail)

    return (
        <>
            <Seo title='Work' description={workPage.summary} />

            <SiteShell>
                <PageHero
                    roman={workPage.headline.roman}
                    italic={workPage.headline.italic}
                    summary={workPage.summary}
                    stacked
                />

                <section id='all-projects' aria-label='All projects' className='w-full pb-24'>
                    <div className='flex w-full flex-col gap-8 lg:flex-row lg:items-end'>
                        <div className='flex shrink-0 items-center gap-2 px-5 md:px-12 lg:w-72 lg:pb-24'>
                            <span aria-hidden='true' className='flex text-ink/35'>
                                <ChevronLeft className='size-3.5' />
                                <ChevronLeft className='-ml-2 size-3.5' />
                                <ChevronLeft className='-ml-2 size-3.5' />
                            </span>

                            <span className='label text-ink/60'>{workPage.railLabel}</span>
                        </div>

                        <div
                            ref={rail}
                            className='no-scrollbar flex w-full cursor-grab gap-6 overflow-x-auto px-5 pb-4 md:px-12 lg:pr-12 lg:pl-0'
                        >
                            {projects.map((project, i) => (
                                <div
                                    key={project.slug}
                                    data-anim='rise'
                                    data-anim-from='28'
                                    data-anim-delay={Math.min(i, 5) * 0.06}
                                    className='w-[62vw] shrink-0 sm:w-[40vw] lg:w-62'
                                >
                                    <ProjectCard project={project} />
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </SiteShell>
        </>
    )
}

export default Work
